import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { ROUTE_TICKETS } from './constants';
import TicketBuilderAside from './ticket-builder-aside';
import CheckoutButton from './checkout-button';

export default class SelectExtrasAside extends React.Component {
    constructor(props) {
        super(props);

        this.onClickContinue = this.onClickContinue.bind(this);
    }

    onClickContinue(e, onContinue) {
        if (!this.props.isNextStepAvailable) {
            e.preventDefault();
        }

        onContinue('Continue', ROUTE_TICKETS);
    }

    onCheckout(mc, onContinue) {
        this.props.onStartCheckout(mc);
        this.triggerContinue(onContinue, mc ? 'Pay with Mastercard' : 'Pay');
    }

    triggerContinue(onContinue, actionCaption) {
        onContinue(actionCaption, ROUTE_TICKETS);
    }

    renderNextStepPanel(onContinue) {
        const stateCss = this.props.isNextStepAvailable ? '' : 'is-disabled';
        return (
            <div className="ticket-builder__steps-controls">
                <Link
                    className={`ticket-builder__button button button--super button--icon ${stateCss}`}
                    to={this.props.nextRoute}
                    onClick={(e) => this.onClickContinue(e, onContinue)}
                >
                    <span>Continue</span>
                    <svg className="icon button__arrow-left" width="14" height="12" focusable="false">
                        <use xlinkHref="#icon-arrow-right"></use>
                    </svg>
                </Link>
            </div>
        );
    }

    renderCheckoutPanel(onContinue) {
        return (
            <div className="ticket-builder__pay-controls">
                <CheckoutButton
                    onStartCheckout={(mc) => this.onCheckout(mc, onContinue)}
                    isDisabled={!this.props.isReadyToPay}
                />
                <div className="throttle">
                    <span>We are experiencing high volumes of traffic at the minute. Please try again.</span>
                </div>
            </div>
        );
    }

    renderPanel(onContinue) {
        if (this.props.isNextStepAvailable) {
            return this.renderNextStepPanel(onContinue);
        }

        return this.renderCheckoutPanel(onContinue);
    }


    render() {
        return (
            <TicketBuilderAside productGroupsList={this.props.productGroupsList}
                basket={this.props.basket}
                onToggleBasketMobile={this.props.onToggleBasketMobile}
                renderControls={(onContinue) => this.renderPanel(onContinue)}
                basketUrl={this.props.basketUrl} />
        );
    }
}

SelectExtrasAside.propTypes = {
    productGroupsList: PropTypes.array,
    basket: PropTypes.object,
    onToggleBasketMobile: PropTypes.func,
    onStartCheckout: PropTypes.func.isRequired,
    nextRoute: PropTypes.string.isRequired,
    currentScenario: PropTypes.string.isRequired,
    isNextStepAvailable: PropTypes.bool.isRequired,
    isReadyToPay: PropTypes.bool.isRequired
};
